import React, { ReactNode } from 'react'

import PdfAttachment from './pdf'
import PhotoAttachment from './photo'
import VideoAttachment from './video'
import { Attachment } from '~graphql/generated/graphql'
import { AttachmentType } from '~graphql/generated/graphql'

export type AttachmentItemProps = {
    attachment: Attachment
    onRemove?: () => void
}

export function getAttachmentComponent(
    attachment: Attachment,
    index?: number,
    onRemoveAttachment?: (index: number) => void,
): ReactNode {
    switch (attachment.type) {
        case AttachmentType.Pdf:
            return (
                <PdfAttachment
                    attachment={attachment}
                    onRemove={
                        onRemoveAttachment && index !== undefined
                            ? () => onRemoveAttachment(index)
                            : undefined
                    }
                />
            )
        case AttachmentType.Video:
            return (
                <VideoAttachment
                    attachment={attachment}
                    onRemove={
                        onRemoveAttachment && index !== undefined
                            ? () => onRemoveAttachment(index)
                            : undefined
                    }
                />
            )
        default:
            return (
                <PhotoAttachment
                    attachment={attachment}
                    onRemove={
                        onRemoveAttachment && index !== undefined
                            ? () => onRemoveAttachment(index)
                            : undefined
                    }
                />
            )
    }
}
